/* ============================================================
   DATZZY — Localization layer
   ------------------------------------------------------------
   The storefront language is POLISH. German is prepared as a
   structural stub but is intentionally NOT translated yet.

   Two kinds of copy:
   1. Dynamic / generated UI strings (chrome, cart, footer, and
      the shared microcopy used by the PDP and collection scripts)
      live here, keyed and locale-aware via DZ_T(key).
   2. Long-form page prose lives inline in each page's HTML,
      already written in Polish. When German is added, those
      page bodies become the next extraction target — Shopify's
      native translations can also supply localized content.

   To switch the active locale, change DZ_LOCALE. Falls back to
   Polish, then to the key itself, if a string is missing.
   ============================================================ */
(function(){
  const STRINGS = {
    pl:{
      // nav
      'nav.products':'Produkty',
      'nav.science':'Jak to działa?',
      'nav.education':'Edukacja',
      'nav.about':'O nas',
      'nav.work':'Współpraca',
      'nav.faq':'FAQ',
      'nav.shopNow':'Kup teraz',
      'nav.account':'Konto',
      'nav.cart':'Koszyk',
      'nav.menu':'Menu',
      'nav.close':'Zamknij',
      'nav.language':'Język',
      'nav.viewAll':'Zobacz wszystkie produkty',
      'nav.shopSystem':'Kup cały system',
      'a11y.skip':'Przejdź do treści',
      // cart
      'cart.title':'Twój koszyk',
      'cart.empty':'Twój koszyk jest pusty.',
      'cart.exploreSystem':'Poznaj system',
      'cart.subtotal':'Suma częściowa',
      'cart.checkout':'Przejdź do kasy',
      'cart.oneTime':'Jednorazowo',
      // footer
      'footer.tagline':'Lepsze Oddychanie Wspiera<br/><span class="accent">Lepszy Komfort Funkcjonowania</span>',
      'footer.followUs':'Obserwuj nas',
      'footer.col.shop':'Produkty',
      'footer.col.company':'Informacje',
      'footer.col.support':'Pomoc',
      'footer.link.magnetic':'Magnetyczna opaska na nos',
      'footer.link.nasal':'Plastry na nos',
      'footer.link.mouth':'Plastry na usta',
      'footer.link.collagen':'Plastry na usta z kolagenem',
      'footer.link.replacement':'Uzupełniające plastry',
      'footer.link.howItWorks':'Jak to działa?',
      'footer.link.education':'Edukacja',
      'footer.link.aboutDatzzy':'O DATZZY',
      'footer.link.work':'Współpraca',
      'footer.link.contact':'Kontakt',
      'footer.link.faq':'FAQ',
      'footer.link.shipping':'Dostawa i zwroty',
      'footer.news.title':'Bądź na bieżąco z DATZZY',
      'footer.news.text':'Nowości produktowe, porady dotyczące oddychania i oferty dostępne tylko dla subskrybentów.',
      'footer.news.placeholder':'Wpisz swój e-mail',
      'footer.rights':'© 2026 DATZZY. Wszelkie prawa zastrzeżone.',
      'footer.privacy':'Polityka prywatności',
      'footer.terms':'Regulamin sklepu',
      // product / collection shared microcopy
      'cat.nasal':'Oddychanie nosem',
      'cat.mouth':'Oddychanie przez usta',
      'cat.refill':'Zapasy',
      'cat.bundle':'Zestaw',
      'ui.addToCart':'Dodaj do koszyka',
      'ui.subscribeSave':'Subskrybuj i oszczędzaj',
      'ui.reviews':'opinii',
      'ui.verifiedReviews':'zweryfikowanych opinii',
      'ui.save':'Oszczędź',
      'ui.oneTimePurchase':'Zakup jednorazowy',
      'ui.subscribeBenefits':'Oszczędź 15% przy każdym zamówieniu · Darmowa dostawa · Anuluj w każdej chwili',
      'ui.off':'TANIEJ',
      'ui.step':'Krok',
      'ui.addBundle':'Dodaj zestaw do koszyka'
    },
    // German — prepared structure, intentionally not implemented yet.
    de:{}
  };

  window.DZ_LOCALE = 'pl';
  window.DZ_I18N = STRINGS;
  window.DZ_T = function(key){
    const loc = STRINGS[window.DZ_LOCALE] || {};
    if(key in loc) return loc[key];
    if(key in STRINGS.pl) return STRINGS.pl[key]; // fallback to Polish
    return key;
  };

  /* ============================================================
     SHOPIFY MARKETS — DEMO display formatting only
     ------------------------------------------------------------
     Architecture target:  Poland market -> PLN,  Germany market -> EUR.

     IMPORTANT: this is NOT a custom currency system. Final currency,
     localized/market pricing and checkout currency will be handled by
     **Shopify Markets**. The code below is FRONTEND/PROTOTYPE display
     only — it formats the single EUR base price for preview purposes:
       - PL selector -> PLN (demo conversion)
       - DE selector -> EUR (base)
     No checkout currency logic is implemented here.

     Catalog prices stay a single EUR base (no per-market duplication).
     Market-specific prices can be added later WITHOUT duplicating product
     logic — e.g. an optional marketPrices:{pl,de} per product, or
     (preferred) Shopify Markets price lists. DZ_PRICE is the seam. */
  const MARKETS = {
    pl:{ market:'pl', currency:'PLN', symbol:'zł', demoRate:4.30 }, // demo rate only
    de:{ market:'de', currency:'EUR', symbol:'€',  demoRate:1 }
  };
  window.DZ_MARKETS = MARKETS;
  window.DZ_MARKET = (function(){ try{ return localStorage.getItem('dz_market') || 'pl'; }catch(e){ return 'pl'; } })();

  // Format an EUR base amount for the active market (DEMO). Never throws —
  // falls back to the plain € base so price rendering can't break the page.
  window.DZ_PRICE = function(eurBase){
    try{
      const eur = (+eurBase || 0);
      const eurStr = '€' + (Number.isInteger(eur) ? eur : eur.toFixed(2));
      const m = MARKETS[window.DZ_MARKET];
      if(!m || m.currency === 'EUR') return eurStr;
      return Math.round(eur * m.demoRate) + ' ' + m.symbol; // PLN demo
    }catch(e){ return '€' + eurBase; }
  };
})();
